import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    selectedUnit: {
        unit: {},
        index: null
    },
    selectedModule: null,
    selectedContent: {
        title: '',
        description: '',
        media: '',
        type: ''
    }
};

const selectedContentSlice = createSlice({
    name: 'selectedContentSlice',
    initialState,
    reducers: {
        setSelectedUnit: (state, { payload }) => {
            state.selectedUnit = payload;
        },
        setSelectedModule: (state, { payload }) => {
            state.selectedModule = payload;
        },
        setSelectedContent: (state, { payload }) => {
            state.selectedContent = payload;
        }
    }
});

export const { setSelectedContent, setSelectedModule, setSelectedUnit } =
    selectedContentSlice.actions;
export default selectedContentSlice.reducer;
